<template>
  <main>
    <PageHeader title="Movimentações da Ferramenta" />

    <div class="row">
      <div class="col-4 text-brand-5 text-weight-bold">
        Nome da Ferramenta
        <q-input dense outlined v-model="nomeFerramenta" :disable="true" />
      </div>

      <div class="col-2 q-ml-sm text-brand-5 text-weight-bold">
        Status Atual

        <q-input dense outlined v-model="statusFerramenta" :disable="true">
          <template v-slot:prepend>
            <span
              v-if="statusFerramenta == 'Disponível'"
              class="elipse q-mr-sm bg-positive"
            ></span>
            <span
              v-if="statusFerramenta == 'Em Uso'"
              class="elipse q-mr-sm bg-warning"
            ></span>
            <span
              v-if="statusFerramenta == 'Manutenção Garantia'"
              class="elipse q-mr-sm"
              style="background: #424242"
            ></span>
            <span
              v-if="statusFerramenta == 'Manutenção'"
              class="elipse q-mr-sm bg-red"
            ></span>
            <span
              v-if="statusFerramenta == 'Em Trânsito'"
              class="elipse q-mr-sm"
              style="background: #2d3e6e"
            ></span>
            <span
              v-if="
                statusFerramenta == 'Removida' ||
                statusFerramenta == 'Calibração'
              "
              class="elipse q-mr-sm"
              style="background: #383737"
            ></span>
            <span
              v-if="statusFerramenta == 'Retorno em Garantia'"
              class="elipse q-mr-sm"
              style="background: #383737"
            ></span>
            <span
              v-if="statusFerramenta == 'Desmobilizada'"
              class="elipse q-mr-sm"
              style="background: #fa9726"
            ></span>
            <span
              v-if="statusFerramenta == 'Reativação'"
              class="elipse q-mr-sm"
              style="background: #473fe8"
            ></span>
            <span
              v-if="statusFerramenta == 'Descartada'"
              class="elipse q-mr-sm"
              style="background: #b0cde8"
            ></span>
            <span
              v-if="statusFerramenta == 'Sucata'"
              class="elipse q-mr-sm"
              style="background: #736d6a"
            ></span>
            <span
              v-if="statusFerramenta == 'Furto'"
              class="elipse q-mr-sm"
              style="background: #6b1215"
            ></span>
            <span
              v-if="statusFerramenta == 'Aguardando Calibração'"
              class="elipse q-mr-sm"
              style="background: #11009e"
            ></span>
          </template>
        </q-input>
      </div>
    </div>
    <span
      v-if="semDados"
      class="row col-12 text-h6 justify-center q-mt-xl text-brand-5 text-weight-bold"
      >Ferramenta Sem Movimentações</span
    >

    <div v-else class="q-mt-sm">
      <div class="row col-12 q-mt-lg">
        <p
          v-if="listaMovimentacao.length > 0"
          class="text-h6 self-end text-brand-5"
        >
          Últimas Movimentações da Ferramenta
        </p>
      </div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        id="customers"
        class="q-mt-sm tabela-tamanho-fixo"
        dense
        hide-pagination
        :rows="listaMovimentacao"
        :hide-bottom="listaMovimentacao.length > 0"
        :columns="columns"
        no-data-label="Sem movimentações"
        :rows-per-page-options="[0]"
        :filter="filter"
        v-model:pagination="pagination"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              <span>{{ props.row.uuid }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.numero }}</span>
            </q-td>
            <q-td>
              <span>{{
                props.row.create_at.split(" ")[0].split("-").reverse().join("/")
              }}</span>
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.status_anterior == 'disponivel'
                    ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                    : props.row.status_anterior == 'manutencao_garantia'
                    ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                    : props.row.status_anterior == 'uso'
                    ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                    : props.row.status_anterior == 'manutencao'
                    ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                    : props.row.status_anterior == 'em_transito'
                    ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                    : props.row.status_anterior == 'removida' ||
                      props.row.status_anterior == 'calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status_anterior == 'retorno_em_garantia'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status_anterior == 'desmobilizada'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status_anterior == 'reativacao'
                    ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                    : props.row.status_anterior == 'descartada'
                    ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                    : props.row.status_anterior == 'sucata'
                    ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                    : props.row.status_anterior == 'furto'
                    ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                    : props.row.status_anterior == 'aguardando_reparo'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status_anterior == 'aguardando_calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : ''
                "
                class="row col-12 no-wrap align items-center nao-quebrar-linha"
              >
                <span
                  v-if="props.row.status_anterior == 'disponivel'"
                  class="elipse q-mr-sm bg-positive"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'uso'"
                  class="elipse q-mr-sm bg-warning"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'manutencao_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #424242"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'manutencao'"
                  class="elipse q-mr-sm bg-red"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'em_transito'"
                  class="elipse q-mr-sm"
                  style="background: #2d3e6e"
                ></span>
                <span
                  v-if="
                    props.row.status_anterior == 'removida' ||
                    props.row.status_anterior == 'calibracao'
                  "
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'retorno_em_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'desmobilizada'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'reativacao'"
                  class="elipse q-mr-sm"
                  style="background: #473fe8"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'descartada'"
                  class="elipse q-mr-sm"
                  style="background: #b0cde8"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'sucata'"
                  class="elipse q-mr-sm"
                  style="background: #736d6a"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'furto'"
                  class="elipse q-mr-sm"
                  style="background: #6b1215"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'aguardando_reparo'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status_anterior == 'aguardando_calibracao'"
                  class="elipse q-mr-sm"
                  style="background: #11009e"
                ></span>
                <div
                  v-if="props.row.status_anterior == 'disponivel'"
                  style="width: fit-content; background: #e8ffec"
                  class="text-brand-5 text-bold"
                >
                  {{ "Disponivel" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'uso'"
                  style="width: fit-content; background: #fefed1"
                  class="text-brand-5 text-bold"
                >
                  {{ "Em Uso" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'manutencao_garantia'"
                  style="width: fit-content"
                  class="text-brand-5 text-bold no-wrap"
                >
                  {{ "Manutenção Garantia" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'manutencao'"
                  style="width: fit-content"
                  class="text-red text-bold"
                >
                  {{ "Manutenção" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'em_transito'"
                  style="width: fit-content; color: #192957"
                  class="text-bold"
                >
                  {{ "Em Trânsito" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'removida'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Removida" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'retorno_em_garantia'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Retorno Em Garantia" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'desmobilizada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Desmobilizada" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'reativacao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Reativação" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'descartada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Descartada" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'sucata'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Sucata" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'furto'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Furto" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'aguardando_reparo'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Reparo" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Calibração" }}
                </div>
                <div
                  v-if="props.row.status_anterior == 'aguardando_calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Calibração" }}
                </div>
              </div>
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.status_atual == 'disponivel'
                    ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                    : props.row.status_atual == 'manutencao_garantia'
                    ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                    : props.row.status_atual == 'uso'
                    ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                    : props.row.status_atual == 'manutencao'
                    ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                    : props.row.status_atual == 'em_transito'
                    ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                    : props.row.status_atual == 'removida' ||
                      props.row.status_atual == 'calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status_atual == 'retorno_em_garantia'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status_atual == 'desmobilizada'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status_atual == 'reativacao'
                    ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                    : props.row.status_atual == 'descartada'
                    ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                    : props.row.status_atual == 'sucata'
                    ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                    : props.row.status_atual == 'furto'
                    ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                    : props.row.status_atual == 'aguardando_reparo'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status_atual == 'aguardando_calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : ''
                "
                class="row col-12 no-wrap align items-center"
              >
                <span
                  v-if="props.row.status_atual == 'disponivel'"
                  class="elipse q-mr-sm bg-positive"
                ></span>
                <span
                  v-if="props.row.status_atual == 'uso'"
                  class="elipse q-mr-sm bg-warning"
                ></span>
                <span
                  v-if="props.row.status_atual == 'manutencao_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #424242"
                ></span>
                <span
                  v-if="props.row.status_atual == 'manutencao'"
                  class="elipse q-mr-sm bg-red"
                ></span>
                <span
                  v-if="props.row.status_atual == 'em_transito'"
                  class="elipse q-mr-sm"
                  style="background: #2d3e6e"
                ></span>
                <span
                  v-if="
                    props.row.status_atual == 'removida' ||
                    props.row.status_atual == 'calibracao'
                  "
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status_atual == 'retorno_em_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status_atual == 'desmobilizada'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status_atual == 'reativacao'"
                  class="elipse q-mr-sm"
                  style="background: #473fe8"
                ></span>
                <span
                  v-if="props.row.status_atual == 'descartada'"
                  class="elipse q-mr-sm"
                  style="background: #b0cde8"
                ></span>
                <span
                  v-if="props.row.status_atual == 'sucata'"
                  class="elipse q-mr-sm"
                  style="background: #736d6a"
                ></span>
                <span
                  v-if="props.row.status_atual == 'furto'"
                  class="elipse q-mr-sm"
                  style="background: #6b1215"
                ></span>
                <span
                  v-if="props.row.status_atual == 'aguardando_reparo'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status_atual == 'aguardando_calibracao'"
                  class="elipse q-mr-sm"
                  style="background: #11009e"
                ></span>
                <div
                  v-if="props.row.status_atual == 'disponivel'"
                  style="width: fit-content; background: #e8ffec"
                  class="text-brand-5 text-bold"
                >
                  {{ "Disponivel" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'uso'"
                  style="width: fit-content; background: #fefed1"
                  class="text-brand-5 text-bold"
                >
                  {{ "Em Uso" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'manutencao_garantia'"
                  style="width: fit-content"
                  class="text-brand-5 text-bold"
                >
                  {{ "Manutenção Garantia" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'manutencao'"
                  style="width: fit-content"
                  class="text-red text-bold"
                >
                  {{ "Manutenção" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'em_transito'"
                  style="width: fit-content; color: #192957"
                  class="text-bold"
                >
                  {{ "Em Trânsito" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'removida'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Removida" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'retorno_em_garantia'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Retorno Em Garantia" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'desmobilizada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Desmobilizada" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'reativacao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Reativação" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'descartada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Descartada" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'sucata'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Sucata" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'furto'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Furto" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'aguardando_reparo'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Reparo" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Calibração" }}
                </div>
                <div
                  v-if="props.row.status_atual == 'aguardando_calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Calibração" }}
                </div>
              </div>
            </q-td>
            <q-td>
              <span>{{ props.row.observacao }}</span>
            </q-td>
            <q-td class="text-left" key="nomeFornecedor" :props="props">{{
              props.row.fornecedor_nome
            }}</q-td>
            <q-td class="text-left" key="cnpj" :props="props">{{
              props.row.fornecedor_cnpj
            }}</q-td>
            <q-td class="text-left" key="observacao" :props="props">{{
              props.row.documentos?.length
            }}</q-td>
            <q-td>
              <div class="image-upload row col-12 justify-center">
                <q-btn
                  color="blue-6"
                  round
                  size="sm"
                  icon="add"
                  @click="enviar(props.row.uuid, (selecionaImagem = true))"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="listaMovimentacao.length > 0"
        class="row justify-start q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
      <q-dialog v-model="selecionaImagem" style="min-height: 100vh">
        <q-card style="width: 1024px; max-width: 80vw">
          <q-separator />
          <q-card-section style="max-height: 800vh" class="scroll">
            <UploadComponentDocumento
              :uuid="movimentacao.uuid"
              :ferramenta_uuid="uuidFerramenta"
            />
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </main>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import UploadComponentDocumento from "./UploadComponentDocumento.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { UploadComponentDocumento, PageHeader },
  props: ["uuid", "atualizar"],

  setup(props) {
    const store = useStore();
    const route = useRoute();
    const listaMovimentacao = ref([]);
    const movimentacao = ref({
      uuid: "",
    });
    const disable = ref(true);

    const nomeFerramenta = ref("");
    const statusFerramenta = ref("");

    const uuidFerramenta = ref("");
    const id = route.params.id;
    const selecionaImagem = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 5,
    });

    const columns = [
      {
        name: "uuid",
        label: "ID",
        field: "uuid",
        align: "left",
        sortable: false,
      },
      {
        name: "numero",
        label: "Numero",
        field: "numero",
        align: "left",
        sortable: false,
      },
      {
        name: "create_at",
        label: "Data de Mudança de Status",
        field: "create_at",
        align: "left",
        sortable: true,
      },
      {
        name: "status_anterior",
        label: "Status Anterior",
        field: "status_anterior",
        align: "left",
        sortable: false,
      },
      {
        name: "status_atual",
        label: "Status Atual",
        field: "status_atual",
        align: "left",
        sortable: false,
      },
      {
        name: "observacao",
        label: "Observação",
        field: "observacao",
        align: "left",
        sortable: false,
      },
      {
        name: "nomeFornecedor",
        label: "Nome Fornecedor",
        align: "left",
        sortable: false,
      },
      {
        name: "cnpj",
        label: "CNPJ",
        align: "left",
        sortable: false,
      },
      {
        name: "anexosQtd",
        label: "Anexos Qtd",
        align: "left",
      },
      {
        name: "url",
        label: "Anexos",
        field: "url",
        align: "left",
      },
    ];
    let semDados = ref(false);

    let listarMovimentacao = async (page = 0, rowsPerPage = 5) => {
      disable.value = true;
      let resposta = await store.dispatch("fer/listarMovimentacao", {
        uuid: props.uuid,
        perPage: rowsPerPage,
        page: page,
        ferramenta_uuid: id,
      });
      listaMovimentacao.value = resposta.resposta.result.data;
      if (listaMovimentacao.value.length == 0) {
        semDados.value = true;
      }
      nomeFerramenta.value =
        resposta.resposta.result.ferramenta?.ferramenta_nome;
      switch (resposta.resposta.result.ferramenta?.ferramenta_status) {
        case "disponivel":
          statusFerramenta.value = "Disponível";
          break;
        case "manutencao":
          statusFerramenta.value = "Manutenção";
          break;
        case "uso":
          statusFerramenta.value = "Em Uso";
          break;
        case "manutencao_garantia":
          statusFerramenta.value = "Manutenção Garantia";
          break;
        case "removida":
          statusFerramenta.value = "Removida";
          break;
        case "reativacao":
          statusFerramenta.value = "Reativação";
          break;
        case "desmobilizada":
          statusFerramenta.value = "Desmobilizada";
          break;
        case "retorno_em_garantia":
          statusFerramenta.value = "Retorno em Garantia";
          break;
        case "descartada":
          statusFerramenta.value = "Descartada";
          break;
        case "furto":
          statusFerramenta.value = "Furto";
          break;
        case "sucata":
          statusFerramenta.value = "Sucata";
          break;
        case "aguardando_reparo":
          statusFerramenta.value = "Aguardando Reparo";
          break;
        case "calibracao":
          statusFerramenta.value = "Calibração";
          break;
        case "em_transito":
          statusFerramenta.value = "Em Trânsito";
          break;
        case "aguardando_calibracao":
          statusFerramenta.value = "Aguardando Calibração";
          break;
        default:
          break;
      }
      pagination.value.rowsPerPage = resposta.resposta.result.per_page;
      pagination.value.rowsNumber = resposta.resposta.result.total;
      pagination.value.page = resposta.resposta.result.current_page;
      disable.value = false;
    };

    let enviar = async (uuid) => {
      movimentacao.value.uuid = uuid;
      uuidFerramenta.value = props.uuid;
    };

    const formataDataHora = (dataHora) => {
      const data = dataHora
        .toLocaleString()
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      const hora = dataHora
        .toLocaleString()
        .split(" ")[1]
        .replace(".000000", "");

      return `${data} ${hora}`;
    };

    onMounted(() => {
      listarMovimentacao();
    });

    watch(
      () => props.atualizar,
      () => {
        listarMovimentacao();
      }
    );

    watch(props.uuid, () => {
      listarMovimentacao();
    });

    const handleRequest = async () => {
      listarMovimentacao(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    return {
      listarMovimentacao,
      formataDataHora,
      enviar,
      listaMovimentacao,
      columns,
      disable,
      nomeFerramenta,
      statusFerramenta,
      filter: ref(""),
      selecionaImagem,
      movimentacao,
      uuidFerramenta,
      pagination,
      semDados,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.nao-quebrar-linha {
  display: flex;
  flex-wrap: nowrap !important;
}
thead tr th {
  white-space: pre-wrap;
}
tbody tr td {
  white-space: pre-wrap;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
</style>
